import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import Button from 'components/basic/Button/Button';
import TextInput from 'components/basic/inputs/TextInput';
import ErrorPanel from 'components/basic/panels/ErrorPanel';
import UnlockSuccess from 'components/wallet/unlock/shared/UnlockSuccess';
import { makeEthersErrorHumanRedable } from 'lib/ethereum/ethersErrors';
import {
  UNLOCK_WALLET_SECRET,
  unlockPrivateKeyWallet,
  unlockByMnemonicPhrase,
} from 'lib/ethereum/wallets/privateKeyWallet';

import UnlockLayout from './UnlockLayout';

const Heading = styled.h2`
  margin-top: 0;
  padding-top: 0;
  font-size: var(--medium);
`;

const Content = styled.div`
  .isMobileStyle & {
    padding: 20px;
  }
`;

const UnlockWrap = styled.div`
  padding: 40px 0 10px;
  text-align: center;
`;

type Props = {
  layout: 'modal' | 'page';
  onBack: () => void;
  onUnlock: (
    publicKey: string,
    privateKeyEncrypted: string,
    personalSecret: string
  ) => Promise<void>;
};

export default function DetailPrivateKey({ onUnlock, onBack, layout }: Props) {
  const [errorMessage, setErrorMessage] = useState('');
  const [processing, setProcessing] = useState(false);

  const [unlockOk, setUnlockOk] = useState(false);
  const [text, setText] = useState('');

  const handleUnlock = useCallback(() => {
    setProcessing(true);
    const textTrimed = text.trim();
    const byMnemonic = textTrimed.split(' ').length > 3;
    if (errorMessage) {
      setErrorMessage('');
    }
    (byMnemonic
      ? unlockByMnemonicPhrase(textTrimed, UNLOCK_WALLET_SECRET)
      : unlockPrivateKeyWallet(textTrimed, UNLOCK_WALLET_SECRET)
    )
      .then(wallet => {
        return onUnlock(
          wallet.publicKey,
          wallet.encryptedKey,
          wallet.personalSecret
        );
      })
      .then(() => {
        setUnlockOk(true);
      })
      .catch(error => {
        console.warn(error);
        setProcessing(false);
        setErrorMessage(makeEthersErrorHumanRedable(error));
      });
  }, [errorMessage, onUnlock, text]);

  const unlockDisabled = !text || processing;

  return (
    <UnlockLayout
      selectedDetail="privateKey"
      isQrScren={false}
      onClose={onBack}
      closeDisabled={processing}
      layout={layout}
      isDetail
      // css={{ zIndex: 99999999 }}
    >
      {unlockOk ? (
        <UnlockSuccess />
      ) : (
        <form
          onSubmit={event => {
            event.preventDefault();
            if (!unlockDisabled) {
              handleUnlock();
            }
          }}
        >
          {errorMessage && (
            <ErrorPanel message={errorMessage} marginBottom={8} />
          )}

          <Content>
            <Heading>Enter your Private Key or Mnemoic phrase</Heading>
            <TextInput
              type="text"
              disabled={processing}
              onChange={value => {
                setText(value);
                if (errorMessage) {
                  setErrorMessage('');
                }
              }}
              value={text}
              placeholder={`"0x..." or mnemoic as "lecture health jealous attract suit ..."`}
            />
            <UnlockWrap>
              <Button
                inline
                widePadding
                disabled={unlockDisabled}
                onClick={handleUnlock}
              >
                Connect Wallet
              </Button>
            </UnlockWrap>
          </Content>
        </form>
      )}
    </UnlockLayout>
  );
}
